// === Global Cart Event Interceptor ===
(function () {
  const originalFetch = window.fetch;
  let debounceTimer;

  function fireCartEvent(data) {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: data
        })
      );
    }, 300);
  }

  window.fetch = function (...args) {
    const url = args[0];
    const options = args[1] || {};

    return originalFetch.apply(this, args).then((response) => {
      const clonedResponse = response.clone();

      if (typeof url === "string") {
        let shouldFireEvent = false;

        if (url.includes("/cart/add")) {
          shouldFireEvent = true;
        }

        if (url.includes("/cart/change") && options.body) {
          try {
            const body = JSON.parse(options.body);

            if (body.quantity === 0) {
              shouldFireEvent = true;
            }
          } catch (e) {}
        }

        if (shouldFireEvent) {
          clonedResponse
            .json()
            .then((data) => {
              fireCartEvent(data);
            })
            .catch(() => {});
        }
      }

      return response;
    });
  };
})();

// === MiniCart Component ===
class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.querySelector("cart-drawer");

    this.header =
      document.querySelector("sticky-header") ||
      document.getElementById("shopify-section-header");

    this.renderQueue = Promise.resolve();

    new IntersectionObserver(
      this.handleIntersection.bind(this)
    ).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const miniCart = document.getElementById("mini-cart");

        if (!miniCart) return;

        miniCart.innerHTML =
          this.getSectionInnerHTML(
            html,
            ".shopify-section"
          );

        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: null
          })
        );
      })
      .catch((e) => {
        console.error(e);
      });
  }

  //  OPEN function. 
  revealHeaderIfNeeded() {
    if (!this.header) {
      this.header =
        document.querySelector("sticky-header") ||
        document.getElementById("shopify-section-header");
    }

    if (this.header) {
      if (typeof this.header.reveal === "function") {
        this.header.reveal();
      } else {
        this.header.classList.remove(
          "shopify-section-header-hidden"
        );
      }
    }
  }

  open() {
    const detailsElement = this.drawer.querySelector("details");
    if (detailsElement.hasAttribute("open")) return;
    if (document.body.classList.contains(this.drawer.classes.open) ||
        document.body.classList.contains(this.drawer.classes.opening)) {
      detailsElement.setAttribute('open', '');
      detailsElement.classList.add('menu-opening');
      document.dispatchEvent(new CustomEvent('cart:drawer-opened'));
      setTimeout(() => { setHeaderHeight(); setCartHeight(); }, 500);
      return;
    }

    const summaryElement = this.drawer.querySelector("summary");
    summaryElement.click();
    document.dispatchEvent(new CustomEvent('cart:drawer-opened'));
    setTimeout(() => { setHeaderHeight(); setCartHeight(); }, 500);
  }

  renderContents(parsedState) {
    this.renderQueue = this.renderQueue
      .then(() => this._renderContents(parsedState))
      .catch((e) => {
        console.error(
          "[MiniCart] render error:",
          e
        );
      });

    return this.renderQueue;
  }

  _renderContents(parsedState) {
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const element =
        document.getElementById(section.id);

      if (!element) return;

      element.innerHTML =
        this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
    });


    // Re-bind drawer events after innerHTML replacement
    if (this.drawer) {
      this.drawer.mainDetailsToggle =
        this.drawer.querySelector("details");

      if (
        typeof this.drawer.bindEvents === "function"
      ) {
        this.drawer.bindEvents();
      }
    }


    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        detail: parsedState
      })
    );

    this.open();
  }


  getSectionsToRender() {
    return [
      {
        id: "mini-cart",
        section: "mini-cart",
        selector: ".shopify-section"
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section"
      }
    ];
  }


  getSectionInnerHTML(
    html,
    selector = ".shopify-section"
  ) {
    const parsed =
      new DOMParser()
        .parseFromString(
          html,
          "text/html"
        )
        .querySelector(selector);

    return parsed
      ? parsed.innerHTML
      : "";
  }
}


if (!customElements.get("mini-cart")) {
  customElements.define(
    "mini-cart",
    MiniCart
  );
}

// HubSpot Quote Form URL Logic

let hubspotDebounce;
let hubspotFormUrl = "";

const variantBarcodeCache = new Map();

const HUBSPOT_FORM_URL_B2C =
  "https://fcz5w.share-eu1.hsforms.com/29DMRSU2NQ_GBhvwFhcfyjg";

const HUBSPOT_FORM_URL_B2B =
  "https://share-eu1.hsforms.com/2ceBf2dg4RPuRxh5r2uzvOgfcz5w";


function setHubspotQuoteButtonUrl() {
  if (!hubspotFormUrl) return;

  const buttons =
    document.querySelectorAll(
      "#hubspot-quote-btn, #hubspot-quote-btn-checkout"
    );

  buttons.forEach((btn) => {
    btn.setAttribute(
      "href",
      hubspotFormUrl
    );
  });
}


function getBarcodeFromMiniCart(variantId) {
  const element =
    document.querySelector(
      `.mini-cart__navigation [data-variant-id="${variantId}"]`
    );

  return element
    ? element.dataset.barcode || ""
    : "";
}


function getProductHandleFromCartItem(item) {
  if (!item || !item.url) {
    return "";
  }

  try {
    const url = new URL(
      item.url,
      window.location.origin
    );

    const parts =
      url.pathname
        .split("/")
        .filter(Boolean);

    const productsIndex =
      parts.indexOf("products");

    if (productsIndex === -1) {
      return "";
    }

    return (
      parts[productsIndex + 1] || ""
    );
  } catch (error) {
    return "";
  }
}


async function getBarcodeFromProduct(item) {
  const variantId =
    String(item.variant_id || "");

  if (!variantId) {
    return "";
  }

  if (
    variantBarcodeCache.has(
      variantId
    )
  ) {
    return variantBarcodeCache.get(
      variantId
    );
  }

  const handle =
    getProductHandleFromCartItem(item);

  if (!handle) {
    variantBarcodeCache.set(
      variantId,
      ""
    );

    return "";
  }

  try {
    const response =
      await fetch(
        `/products/${encodeURIComponent(handle)}.js`,
        {
          credentials: "same-origin"
        }
      );

    if (!response.ok) {
      variantBarcodeCache.set(
        variantId,
        ""
      );

      return "";
    }

    const product =
      await response.json();

    const variant =
      Array.isArray(product.variants)
        ? product.variants.find(
            (v) =>
              String(v.id) ===
              variantId
          )
        : null;

    const barcode =
      variant?.barcode || "";

    variantBarcodeCache.set(
      variantId,
      barcode
    );

    return barcode;
  } catch (error) {
    console.error(
      "[HubSpot Quote] Failed to fetch barcode:",
      variantId,
      error
    );

    variantBarcodeCache.set(
      variantId,
      ""
    );

    return "";
  }
}


async function getReliableBarcode(item) {
  const variantId =
    String(item.variant_id || "");

  if (!variantId) {
    return "";
  }

  const miniCartBarcode =
    getBarcodeFromMiniCart(
      variantId
    );

  if (miniCartBarcode) {
    variantBarcodeCache.set(
      variantId,
      miniCartBarcode
    );

    return miniCartBarcode;
  }

  return await getBarcodeFromProduct(
    item
  );
}


async function updateHubspotQuoteUrl() {
  clearTimeout(
    hubspotDebounce
  );

  hubspotDebounce =
    setTimeout(async () => {
      try {
        const response =
          await fetch("/cart.js", {
            credentials: "same-origin",
            cache: "no-store"
          });

        if (!response.ok) {
          return;
        }

        const cart =
          await response.json();

        if (
          !cart ||
          !Array.isArray(cart.items)
        ) {
          return;
        }

        const itemsWithBarcodes =
          await Promise.all(
            cart.items.map(
              async (item) => {
                const barcode =
                  await getReliableBarcode(
                    item
                  );

                return {
                  item,
                  barcode
                };
              }
            )
          );


        const prefill =
          itemsWithBarcodes
            .map(
              ({
                item,
                barcode
              }) => {
                const title =
                  item.product_title ||
                  "Produkt";

                const qty =
                  item.quantity || 1;

                const barcodeSuffix =
                  barcode
                    ? ` (${barcode})`
                    : "";

                return `${qty} x ${title}${barcodeSuffix}`;
              }
            )
            .join("\n");


        const params =
          new URLSearchParams();

        params.append(
          "0-1/message",
          prefill
        );


        const mainProduct =
          cart.items.find(
            (item) =>
              item.is_main_product ||
              (
                item.properties &&
                item.properties
                  .is_main_product
              )
          );


        if (
          mainProduct &&
          mainProduct.quantity
        ) {
          params.append(
            "0-1/benotigte_quadratmeter_",
            mainProduct.quantity.toString()
          );
        }


        params.append(
          "0-1/quelle__verstecktes_feld_",
          "Warenkorb"
        );


        const isB2B =
          window.isB2BCustomer === true;

        const baseFormUrl =
          isB2B
            ? HUBSPOT_FORM_URL_B2B
            : HUBSPOT_FORM_URL_B2C;


        hubspotFormUrl =
          `${baseFormUrl}?${params.toString()}`;


        setHubspotQuoteButtonUrl();

      } catch (error) {
        console.error(
          "[HubSpot Quote] Failed to update URL:",
          error
        );
      }
    }, 300);
}


updateHubspotQuoteUrl();

document.addEventListener("click", (e) => {
  const btn = e.target.closest(
    "#hubspot-quote-btn, #hubspot-quote-btn-checkout"
  );
  if (!btn) return;

  e.preventDefault();

  const url =
    hubspotFormUrl ||
    (window.isB2BCustomer === true
      ? HUBSPOT_FORM_URL_B2B
      : HUBSPOT_FORM_URL_B2C);

  window.open(url, "_blank", "noopener");
});

document.addEventListener(
  "cart:updated",
  updateHubspotQuoteUrl
);


document.addEventListener(
  "cart:drawer-opened",
  () => {
    updateHubspotQuoteUrl();

    setTimeout(
      () => updateHubspotQuoteUrl(),
      500
    );

    setTimeout(
      () => setHubspotQuoteButtonUrl(),
      1000
    );
  }
);


document.addEventListener(
  "abtest:cart_sync",
  updateHubspotQuoteUrl
);


let hubspotMutationTimer;

const hubspotObserver =
  new MutationObserver(() => {
    clearTimeout(
      hubspotMutationTimer
    );

    hubspotMutationTimer =
      setTimeout(
        () => updateHubspotQuoteUrl(),
        150
      );
  });


hubspotObserver.observe(
  document.body,
  {
    childList: true,
    subtree: true
  }
);

// CART Height CHANGES

(function () {
  "use strict";

  const LOCK_CLASS =
    "mini-cart-scroll-locked";

  // === MODIFIED: .cart-drawer is now the only scroll owner.
  // Kept as the outer boundary for the upward walk in getScrollContainer(). ===
  const SCROLL_ROOT_SELECTOR = ".cart-drawer";

  let isLocked = false;
  let scrollbarWidth = 0;
  let lockedScrollY = 0;

  let compensatedElement = null;
  let compensatedElementOriginalPaddingTop = "";


  function getScrollbarWidth() {
    return (
      window.innerWidth -
      document.documentElement.clientWidth
    );
  }


  function getHeader() {
    return document.getElementById(
      "shopify-section-header"
    );
  }


  // === MODIFIED: walks up from the touch target and returns the first
  // ancestor that can ACTUALLY scroll, stopping at .cart-drawer.
  // The old closest(".cart-drawer, .mini-cart__main, ...") returned the
  // NEAREST match (.mini-cart__main), which no longer scrolls, so every
  // touchmove inside the cart was being preventDefault()-ed. ===
  function getScrollContainer(target) {
    let el = target;

    while (el && el.nodeType === 1) {
      if (el.scrollHeight > el.clientHeight) {
        const overflowY =
          window.getComputedStyle(el).overflowY;

        if (
          overflowY === "auto" ||
          overflowY === "scroll"
        ) {
          return el;
        }
      }

      if (
        el.matches &&
        el.matches(SCROLL_ROOT_SELECTOR)
      ) {
        break;
      }

      el = el.parentElement;
    }

    return null;
  }

  function applyHeaderFlowCompensation(header, headerHeight) {
    if (
      !header ||
      headerHeight <= 0
    ) {
      return;
    }

    const target =
      header.nextElementSibling;

    if (!target) {
      return;
    }

    removeHeaderFlowCompensation();

    compensatedElement = target;
    compensatedElementOriginalPaddingTop =
      target.style.paddingTop || "";

    target.style.paddingTop =
      headerHeight + "px";
  }


  function removeHeaderFlowCompensation() {
    if (!compensatedElement) {
      return;
    }

    compensatedElement.style.paddingTop =
      compensatedElementOriginalPaddingTop;

    compensatedElement = null;
    compensatedElementOriginalPaddingTop =
      "";
  }


  function lockBackgroundScroll() {
    if (isLocked) {
      return;
    }

    isLocked = true;

    lockedScrollY =
      window.scrollY ||
      window.pageYOffset ||
      0;

    scrollbarWidth =
      getScrollbarWidth();


    const header = getHeader();

    let headerHeight = 0;
    let wasOutOfFlow = false;

    if (header) {
      headerHeight =
        header.getBoundingClientRect().height;

      const position =
        window.getComputedStyle(
          header
        ).position;

      wasOutOfFlow =
        position === "fixed" ||
        position === "absolute";
    }


    document.documentElement.classList.add(
      LOCK_CLASS
    );

    document.body.classList.add(
      LOCK_CLASS
    );


    if (
      header &&
      !wasOutOfFlow &&
      window.getComputedStyle(
        header
      ).position === "fixed"
    ) {
      applyHeaderFlowCompensation(
        header,
        headerHeight
      );
    }


    document.addEventListener(
      "touchmove",
      preventBackgroundTouchMove,
      {
        passive: false
      }
    );
  }


  function unlockBackgroundScroll() {
    if (!isLocked) {
      return;
    }

    isLocked = false;

    document.documentElement.classList.remove(
      LOCK_CLASS
    );

    document.body.classList.remove(
      LOCK_CLASS
    );

    removeHeaderFlowCompensation();


    document.removeEventListener(
      "touchmove",
      preventBackgroundTouchMove,
      {
        passive: false
      }
    );


    restoreScrollPosition();

    requestAnimationFrame(
      restoreScrollPosition
    );
  }


  function restoreScrollPosition() {
    const current =
      window.scrollY ||
      window.pageYOffset ||
      0;

    if (
      Math.abs(
        current - lockedScrollY
      ) < 1
    ) {
      return;
    }

    const previousBehavior =
      document.documentElement.style.scrollBehavior;

    document.documentElement.style.scrollBehavior =
      "auto";

    window.scrollTo(
      0,
      lockedScrollY
    );

    document.documentElement.style.scrollBehavior =
      previousBehavior;
  }


  function preventBackgroundTouchMove(
    event
  ) {
    if (!isLocked) {
      return;
    }

    const scrollContainer =
      getScrollContainer(
        event.target
      );


    // === MODIFIED: getScrollContainer() only returns an element that is
    // genuinely scrollable, so the redundant size re-check was removed. ===
    if (scrollContainer) {
      return;
    }


    event.preventDefault();
  }

  // CART HEIGHT CALCULATION
  // UNCHANGED from the current implementation.
  window.setCartHeight =
    function () {
      const header =
        document.getElementById(
          "shopify-section-header"
        );

      const cart =
        document.getElementById(
          "mini-cart"
        );


      if (!cart) {
        return;
      }


      const viewportHeight =
        window.innerHeight;


      let top = 0;


      if (header) {
        const headerRect =
          header.getBoundingClientRect();


        top = Math.max(
          headerRect.bottom,
          0
        );


        if (
          top === 0 &&
          header.clientHeight > 0
        ) {
          top =
            header.clientHeight;
        }
      }


      const height =
        Math.max(
          viewportHeight - top,
          0
        );


      cart.style.setProperty(
        "--mini-cart-fixed-top",
        top + "px"
      );


      cart.style.height =
        height + "px";
    };

  // CART OPEN EVENT
  document.addEventListener(
    "cart:drawer-opened",
    function () {
      lockBackgroundScroll();

      window.setCartHeight();


      requestAnimationFrame(
        function () {
          window.setCartHeight();
        }
      );
    }
  );

  // WATCH NATIVE DETAILS OPEN/CLOSE
  const drawerObserver =
    new MutationObserver(
      function (mutations) {
        mutations.forEach(
          function (mutation) {
            if (
              mutation.type !==
                "attributes" ||
              mutation.attributeName !==
                "open"
            ) {
              return;
            }


            const target =
              mutation.target;


            if (
              !target ||
              !target.classList ||
              !target.classList.contains(
                "cart-drawer-container"
              )
            ) {
              return;
            }


            if (
              target.hasAttribute(
                "open"
              )
            ) {
              lockBackgroundScroll();

              window.setCartHeight();


              requestAnimationFrame(
                function () {
                  window.setCartHeight();
                }
              );
            } else {
              unlockBackgroundScroll();
            }
          }
        );
      }
    );


  drawerObserver.observe(
    document.body,
    {
      attributes: true,
      attributeFilter: ["open"],
      subtree: true
    }
  );

  // RESIZE
  let resizeTimeout;


  window.addEventListener(
    "resize",
    function () {
      clearTimeout(
        resizeTimeout
      );


      resizeTimeout =
        setTimeout(
          function () {
            if (
              isLocked &&
              compensatedElement
            ) {
              const header = getHeader();

              if (header) {
                compensatedElement.style.paddingTop =
                  header.getBoundingClientRect().height +
                  "px";
              }
            }

            window.setCartHeight();
          },
          100
        );
    }
  );

  // ORIENTATION CHANGE
  window.addEventListener(
    "orientationchange",
    function () {
      window.setCartHeight();
    }
  );

  // INITIAL CALCULATION
  document.addEventListener(
    "DOMContentLoaded",
    function () {
      const container =
        document.querySelector(
          "cart-drawer > .cart-drawer-container"
        );


      if (
        container &&
        container.hasAttribute(
          "open"
        )
      ) {
        lockBackgroundScroll();
      }


      window.setCartHeight();
    }
  );

})();